import { createSlice } from '@reduxjs/toolkit'
import SetNotification from './reducers/SetNotification'
import UnsetNotification from './reducers/UnsetNotification'

export const slice = createSlice({
  name: 'notifications',
  initialState: {
    notificationData: {},
    isShown: false
  },
  reducers: {
    setNotification: SetNotification,
    unsetNotification: UnsetNotification,
  },
})

export const { setNotification, unsetNotification } = slice.actions

export default slice.reducer
